// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HECd","comment":"styles_comment__1L6MQ"};